module.exports = __webpack_public_path__ + "img/holonative_logo.226b9fb7.png";